import { useEffect, memo, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ConfigProvider, theme } from 'antd';
import { useKeycloak } from '@react-keycloak/web';
import { useTranslation } from 'react-i18next';
import Layout from './components/layout';
import { themeStyle } from './app/theme/themeSlice';
import { LoadingScreen } from './components/template';
import bracLoader from './assets/search-loader-brac-v1-01.png';

import { commonState, setLoaderShow } from './app/base/commonSlice';
import WelcmeModal from './components/ui/Welcome-modal/WelcomeModal';

// const options = {
//   icon: {
//     dimensions: {
//       width: { size: 40, units: 'px' },
//       height: { size: 40, units: 'px' },
//     },
//     position: {
//       bottom: { size: 80, units: 'px' },
//     },
//     backgroundColor: '#ff1493',
//     img: 'accessible',
//     zIndex: '15',
//     circular: true,
//   },
// };

function App() {
  const { i18n } = useTranslation();
  const { language } = useSelector(commonState);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const isEnglish = useMemo(() => language === 'en', [language]);
  const { initialized, keycloak } = useKeycloak();
  const dispatch = useDispatch();
  const { loaderShown } = useSelector(commonState);
  const myBracTheme = useSelector(themeStyle);
  const mode = myBracTheme.mode === 'light';

  // useEffect(() => {
  //   // eslint-disable-next-line no-new
  //   new Accessibility(options);
  // }, []);

  // console.log('keycloak', keycloak);

  useEffect(() => {
    const stopLoading = () => {
      setLoading(false);
    };

    const stopError = () => {
      setError(true);
    };

    keycloak.onAuthSuccess = stopLoading;
    keycloak.onAuthError = stopError;
    keycloak.onAuthRefreshSuccess = stopLoading;
  }, [keycloak]);

  useEffect(() => {
    if (!isEnglish) {
      i18n.changeLanguage('en');
    } else {
      i18n.changeLanguage('bn');
    }
  }, [i18n, isEnglish]);

  useEffect(() => {
    if (initialized) {
      // setTimeout(() => {
      dispatch(setLoaderShow(false));
      // }, 2200);
    }
  }, [dispatch, initialized]);

  if (error) {
    return (
      <div className="flex flex-col items-center h-[100vh] bg-gray-100 dark:bg-[#0A0A0A] pt-20">
        <h4 className="text-3xl mb-2">Oops! Try logging in again.</h4>
        <button
          onClick={() => keycloak.login()}
          className=" underline text-blue-700"
        >
          Click here!
        </button>
      </div>
    );
  }

  if ((!initialized || loading) && !loaderShown) {
    return (
      <div className="flex items-center flex-col justify-center h-[100vh] bg-gray-100 dark:bg-[#0A0A0A]">
        <img style={{ width: 70 }} src={bracLoader} alt="loader" />
        Loading......
      </div>
    );
  }

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: mode ? '#d9338a' : '#ddd',
          fontFamily: 'Helvetica-Neue, Arial, Helvetica, sans-serif',
        },
        algorithm: mode ? theme.defaultAlgorithm : theme.darkAlgorithm,
      }}
    >
      <WelcmeModal />

      {loaderShown ? <LoadingScreen /> : <Layout />}
    </ConfigProvider>
  );
}

export default memo(App);
